import React from 'react';
import { GradientCta } from './GradientCta';
import { checkoutUrl } from '../../data/config';
type CheckoutCtaProps = {
  tone?: 'lavender' | 'light';
};

/** „Kérem az azonnali hozzáférést →” — a checkout linket a data/config.ts fájlban kell megadni. */
export function CheckoutCta({
  tone = 'lavender'
}: CheckoutCtaProps) {
  return <GradientCta href={checkoutUrl} tone={tone} checkout data-id="element-48" data-mp="367351z7p39k1">
      Kérem az azonnali hozzáférést →
    </GradientCta>;
}